import { render } from "./NoVisaRequired.vue?vue&type=template&id=194cc2cf&ts=true"
import script from "./NoVisaRequired.ts?vue&type=script&lang=ts"
export * from "./NoVisaRequired.ts?vue&type=script&lang=ts"

import exportComponent from "/codebuild/output/src986595998/src/codestar-connections.eu-central-1.amazonaws.com/git-http/637423171848/eu-central-1/0deacb55-d326-4e40-91f1-5700b2b633c7/studyportals/Visa-Display/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__